import { useSearchParams } from 'react-router-dom';

import { useAvailableBenchmarks } from 'views/portfolio/reporting-queries';

// Repeated (?benchmark=A&benchmark=B) rather than comma-joined: benchmark names are free text.
const BENCHMARK = 'benchmark';

/** Query param carrying the benchmarks the reporting page compares against. */
export const REPORTING_BENCHMARKS_SEARCH_PARAMS = [BENCHMARK] as const;

/**
 * The benchmarks the reporting page compares against, from the `benchmark` query params, in the order
 * they were picked: a line each on the Market Value chart and a row each in Trailing returns. None by
 * default. Picked benchmarks that are no longer offered are dropped, so an old link cannot ask for one.
 */
export const useReportingBenchmarks = () => {
    const [params, setParams] = useSearchParams();
    const { data: availableBenchmarks = [] } = useAvailableBenchmarks();

    const setBenchmarkNames = (benchmarkNames: string[]) => {
        const next = new URLSearchParams(params);
        next.delete(BENCHMARK);
        benchmarkNames.forEach((name) => next.append(BENCHMARK, name));
        setParams(next, { replace: true });
    };

    return {
        // De-duplicated: a hand-edited link can repeat a benchmark, which would draw it twice.
        benchmarkNames: [...new Set(params.getAll(BENCHMARK))].filter((name) => availableBenchmarks.includes(name)),
        availableBenchmarks,
        setBenchmarkNames,
    };
};
